import React from 'react';

import { Card, CardContent, Typography, CardHeader, Box, Accordion, AccordionSummary, AccordionDetails ,Grid } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import CircleIcon from '@mui/icons-material/Circle';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Skills = ({ skills }) => {
  const normalizeCategories = (skillsData) => {
    if (!skillsData) {
      return [];
    }

    if (Array.isArray(skillsData.categories)) {
      return skillsData.categories;
    }

    if (skillsData && typeof skillsData === 'object') {
      return Object.entries(skillsData).map(([displayName, items]) => ({
        displayName,
        skills: Array.isArray(items) ? items : []
      }));
    }

    return [];
  };

  const categories = normalizeCategories(skills);

  if (!categories.length) {
    return <Typography variant="body1">No skills data available</Typography>;
  }

  const renderStars = (rating = 0) => {
    const filledStars = Array.from({ length: 5 }, (_, index) => (
      <CircleIcon key={index} style={{ color: '#1976d2' }} />
    ));
    const emptyStars = Array.from({ length: 5 - rating }, (_, index) => (
      <CircleIcon key={index} style={{ color: '#e0e0e0' }} />
    ));
    return [...filledStars.slice(0, rating), ...emptyStars];
  };

  const renderSkills = (category) => {
    if (!category?.skills?.length) {
      return <Typography variant="body1">No skills data available</Typography>;
    }

    return category.skills.map((skill, index) => (
      <Box
        key={`${category.displayName}-${skill.technology || index}`}
        sx={{ my: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Typography variant="body1" sx={{ mr: 2 }}>
          {skill.technology}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {renderStars(skill.rating || 0)}
        </Box>
      </Box>
    ));
  };

  const renderSkillCategories = () => {
    return (
      <Card sx={{ my: 2 }}>
        <CardHeader
          avatar={
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <SchoolIcon />
              <Typography variant="h6" sx={{ marginLeft: 1 }}>
                Skills
              </Typography>
            </Box>
          }
          sx={{ background: '#efe7d469', color: 'green', p: 1 }}
        />
        <CardContent>
          <Grid container spacing={1}>
            {categories.map((category, index) => (
              <Grid item xs={12} md={12} key={index}>
                <Accordion
                  sx={{
                    '&:hover': {
                      backgroundColor: '#dff0d8'
                    },
                  }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                    <Typography variant="h6" color="primary">
                      {category.displayName}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {renderSkills(category)}
                  </AccordionDetails>
                </Accordion>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    );
  };

  return (
    <div className="skills">
      {renderSkillCategories()}
    </div>
  );
};

export default Skills;
